<template>
  <div class="content">
<!--    <center-nav></center-nav>-->
    <div class="top">
      <div class="top-flex1">
        <div class="top-title">影票小程序</div>
        <div class="top-hint">仅支持已认证小程序</div>
      </div>
      <div class="top-text">一分钟搭建小程序，无需开发 快速上线，专业客服24小时在线答疑</div>
<!--      <div class="top-flex">-->
<!--        <div class="top-flex-box">-->
<!--          <img src="@/assets/img/xcx_icon_djxcx_1.png" alt="">-->
<!--          <div class="box-text">一分钟搭建小程序</div>-->
<!--        </div>-->
<!--        <div class="top-flex-box">-->
<!--          <img src="@/assets/img/xcx_icon_kssx_2.png" alt="">-->
<!--          <div class="box-text">无需开发，快速上线</div>-->
<!--        </div>-->
<!--        <div class="top-flex-box">-->
<!--          <img src="@/assets/img/xcx_icon_kf_3.png" alt="">-->
<!--          <div class="box-text">专业客服24小时在线答疑</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="center">
      <div class="title">选择需要的版本</div>
      <div class="flex">
        <div class="flex-box" v-for="(item,index) in packageList" :key="index">
          <div class="flex-box-top">
            <div class="flex-box-top-title">
              <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                <div>{{ item.name }}</div>
              </el-tooltip>
            </div>
            <div class="flex-box-top-text"></div>
          </div>
          <div class="flex-box-center">
            <div class="flex-box-center-title">{{ item.price }}<span>元/{{ item.num }}{{ item.dateTypeStr }}</span>
            </div>
            <div class="flex-box-center-text">利润分佣{{ item.commissionRate }}%</div>
          </div>
          <div class="flex-box-button" @click="goPay(item,1)">
            立即开通
          </div>
          <div class="flex-box-hint">{{ item.tag }}</div>
        </div>
        <div class="box-span"></div>
      </div>
      <div class="flex-text">
        基础版举例：小A关注了您的公众号，打开您的影票专属推广链接，通过竞价方式购买了2张电影票支付100元，扣除影票成本和技术服务费，订单剩余利润10元。订单放映2小时后结算，您获得70%的利润分佣，即70%*10元=7元。
      </div>
<!--      <div class="title">高级进阶</div>-->
<!--      <div class="text">（开通分销功能，享受粉丝裂变高级功能）</div>-->
<!--      <div class="flex">-->
<!--        <div class="flex-box" v-for="(item,index) in packageProfitList" :key="index">-->
<!--          <div class="flex-box-top">-->
<!--            <div class="flex-box-top-title">-->
<!--              <el-tooltip class="item" effect="dark" :content="item.name" placement="top">-->
<!--                <div>{{ item.name }}</div>-->
<!--              </el-tooltip>-->
<!--            </div>-->
<!--            <div class="flex-box-top-text">开通分销功能享受粉丝裂变高级功能</div>-->
<!--          </div>-->
<!--          <div class="flex-box-center">-->
<!--            <div class="flex-box-center-title">{{ item.price }}<span>元/{{ item.num }}{{ item.dateTypeStr }}</span>-->
<!--            </div>-->
<!--            <div class="flex-box-center-text">利润分佣{{ item.commissionRate }}%</div>-->
<!--          </div>-->
<!--          <div class="flex-box-button" @click="goPay(item,2)">-->
<!--            立即开通-->
<!--          </div>-->
<!--          &lt;!&ndash;          <div class="flex-box-hint">小试牛刀</div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="flex-text">-->
<!--        分销功能举例：您的粉丝小A推广了小B注册，小B下单后小A可以得到一笔推广佣金（佣金比例由您自己设置）。小B再邀请小C注册下单，小B可以得到一级推广佣金，小A得到二级推广佣金。这样您的公众号系统就具备分销高级功能，粉丝裂变的更快，产生的订单收益越多。平均收益能比普通版本高出100%以上。-->
<!--      </div>-->
<!--      <div class="title">版本对比</div>-->
<!--      <Table style="margin-top: 40px" border :columns="columns" :data="list"></Table>-->
    </div>
    <div class="foot">
      <div class="foot-flex">
        <div class="foot-text">关于我们</div>
        <div class="foot-text">法律声明</div>
        <div class="foot-text">廉政举报</div>
        <div class="foot-text">友情链接</div>
      </div>
      <div class="foot-remark">© 2020-2030 shoutu.com 版权所有 ICP：闽DSS2-487545</div>
    </div>
    <activation-item ref="ActivationItem"></activation-item>
  </div>
</template>

<script>
import mini from "@/api/mini";
import {getPlatformUuid} from '@/utils/auth'
import ActivationItem from '@/views/pc/miniProgram/dialog/index.vue'
import {Table} from 'view-design'
import checkRed from '@/assets/img/official/arrow_red.png'
import centerNav from "../../../../components/centerNav";
import CenterNav from "../../../../components/centerNav";

const MiniModel = new mini()
export default {
  components: {
    CenterNav,
    Table,
    ActivationItem
  },
  name: "index",
  data() {
    return {
      columns: [
        {
          title: '功能',
          key: 'fun'
        },
        {
          title: '基础版',
          key: 'basic',
          render: (h, params) => {
            let iconName = params.row.basic
            let renderData = []
            if (iconName) {
              renderData.push(
                h('img', {
                  attrs: {
                    src: iconName,
                    width: 20
                  },
                })
              )
            }
            return renderData
          }
        },
        {
          title: '分销版',
          key: 'distribution',
          render: (h, params) => {
            let iconName = params.row.distribution
            let renderData = []
            if (iconName) {
              renderData.push(
                h('img', {
                  attrs: {
                    src: iconName,
                    width: 20
                  },
                })
              )
            }
            return renderData
          }
        }
      ],
      list: [
        {
          'fun': '获取全国影院信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '获取最新影片信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '获取即将上映影片信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '秒出票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '特惠购票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '竞价购票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '绑定小程序',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '订单报表',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '推广素材库',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '用户裂变模块',
          'basic': '',
          'distribution': checkRed
        },
        {
          'fun': '自定义邀请海报',
          'basic': '',
          'distribution': checkRed
        },
      ],
      packageList: [], // 普通套餐
      packageProfitList: [], // 分销套餐
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    goPay(item, index) {
      if (index === 1) {
        this.$router.push({
          path: '/pc/miniProgram/pay',
          query: {
            platformUuid: getPlatformUuid(),
            isProfit: 1,
            packageId: item.id,
            type: 4,
            snapshotId: 0
          }
        })
      } else {
        let isProfitInt = 1
        this.$refs.ActivationItem.init(this.packageList, item, isProfitInt, item)
      }
      // this.$router.push({
      //   path:'/pc/miniProgram/auto',
      //   query:{
      //     platformUuid:getPlatformUuid(),
      //     isProfit: 1,
      //     packageId:item.id,
      //     type: 4,
      //     snapshotId:0
      //   }
      // })
    },
    getList() {
      let param = {
        appKey: '',
        channelType:0
      }
      MiniModel.getSetList(param).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.packageList = res.data.data.packageList
          this.packageProfitList = res.data.data.packageProfitList
        } else {
          this.$message.error(res.data.info)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.content {
  .top {
    background-image: url("../../../../assets/img/smallprogram_bgNew.png");
    background-size: 100% 100%;
    height: 180px;
    padding: 0 360px;

    .top-title {
      font-size: 48px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFF8C5;
      line-height: 65px;
    }

    .top-text {
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 33px;
    }

    .top-flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 90px;

      .top-flex-box {
        display: flex;
        align-items: center;
        padding: 20px 40px;
        height: 140px;
        background: #FFFFFF;
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;

        .box-text {
          font-size: 18px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #333333;
          line-height: 25px;
        }
      }
    }
  }

  .title {
    font-size: 34px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 47px;
    //padding-top: 100px;
    text-align: center;
  }

  .text {
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #999999;
    line-height: 27px;
    text-align: center;
    margin-top: 8px;
  }

  .flex-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #999999;
    line-height: 20px;
    margin-top: 7px;
    text-align: center;
    padding-bottom: 20px;
  }

  .flex:after {
    content: '';
    width: 285px;
  }
  .box-span{
    width: 285px;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    //margin-top: 40px;
    .flex-box {
      max-width: 355px;
      min-width: 285px;
      // width: 285px;
      height: 323px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      padding: 18px 40px;
      text-align: center;
      position: relative;
      margin-top: 40px;

      .flex-box-top {
        border-bottom: 1px solid #EEEEEE;

        .flex-box-top-title {
          font-size: 20px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          line-height: 27px;
          overflow:hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow:ellipsis;
          cursor: pointer;
        }

        .flex-box-top-text {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #999999;
          line-height: 20px;
          margin-top: 8px;
          padding-bottom: 18px;
        }
      }

      .flex-box-center {
        margin-top: 30px;

        .flex-box-center-title {
          font-size: 32px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          line-height: 44px;

          span {
            font-size: 16px;
          }
        }

        .flex-box-center-text {
          font-size: 18px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #999999;
          line-height: 25px;
          margin-top: 10px;
        }
      }

      .flex-box-button {
        width: 205px;
        height: 42px;
        background: #FF8622;
        border-radius: 2px;
        font-size: 18px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 42px;
        text-align: center;
        margin-top: 40px;
        cursor: pointer;
      }

      .flex-box-hint {
        width: 68px;
        height: 20px;
        background: #FF4F76;
        border-radius: 4px 0 4px 0;
        text-align: center;
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 20px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
}

.center {
  background: #fff;
  padding: 100px 360px;
}

.foot {
  height: 165px;
  background: #333333;
  text-align: center;

  .foot-flex {
    display: flex;
    align-items: center;
    justify-content: center;

    .foot-text {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #FFFFFF;
      line-height: 21px;
      margin: 0 30px;
      margin-top: 46px;
    }

  }
}

.foot-remark {
  margin-top: 32px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #999999;
  line-height: 19px;
}
.top-flex1{
  display: flex;
  padding-top: 40px;
}
.top-hint{
  width: 141px;
  height: 28px;
  background: #FFFFFF;
  border-radius: 4px;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #F0302D;
  line-height: 28px;
  text-align: center;
  margin-left: 12px;
  margin-top: 13px;
}
@media screen and (max-width: 1750px) {
  .top {
    padding: 0 60px !important;
  }

  .center {
    padding: 0px 60px !important;
  }
}
//.center-box{
//  padding: 0px 60px;
//  padding-bottom: 50px;
//  background-color: #ffffff;
//}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/creditCard/index.vue